import { State, StateValue } from 'xstate'

interface ICustomerInfoProps {
  firstName: string
  lastName: string
  dateOfBirth: string
  email: string
  confirmEmail: string
  phone: string
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  postalCode: string
  code: string
  phoneVerificationTimestamp: string
  sex: string
  isSmsTelehealthConsentChecked: boolean
  isTelehealthAndPrivacyConsentChecked: boolean
  selfReportedMeds: string
  allergies: string
  medicalConditions: string
  diagnosis: string
  hasMedicalHistory: string
  hasAllergiesOrReactions: string
  hasSelfReportedMeds: string
  hasOtherQuestions: string
  Q1: string
  A1: string
  Q2: string
  A2: string
  Q3: string
  A3: string
}

export interface ICustomerImage {
  data: string
  mime: string
}

interface ILmnContext {
  customerInfo: ICustomerInfoProps
  codeError: boolean
  lmnStep: number
  lmnProvider: string
  lmnStatus: string
  lmnId: string
  lmnConditions: string[]
  lmnContraindications: string[]
  lmnNotQualified: boolean
  merchant: string
  merchantUuid: string
  merchantLogoUrl: string
  merchantName: string
  merchantWebsite: string
  merchantProcessor: string
  customerImage: ICustomerImage | null
  loading: boolean
  smallLoading: boolean
  onCancel: (() => void) | undefined
}

const getCustomerInfo = ({
  context,
}: State<ILmnContext>): ICustomerInfoProps => context.customerInfo
const getLmnStatus = ({ context }: State<ILmnContext>): string => context.lmnStatus
const getLmnState = ({ value }: State<ILmnContext>): StateValue => (typeof value === 'string' ? value : value.normal)
const getLmnStep = ({ context }: State<ILmnContext>): number => context.lmnStep
const getLmnMerchantName = ({ context }: State<ILmnContext>): string => context.merchantName
const getLmnMerchantLogoUrl = ({ context }: State<ILmnContext>): string => context.merchantLogoUrl
const getLmnMerchantWebsite = ({ context }: State<ILmnContext>): string => context.merchantWebsite
const getLmnMerchantProcessor = ({ context }: State<ILmnContext>): string => context.merchantProcessor
const getLmnConditions = ({ context }: State<ILmnContext>): string[] => context.lmnConditions
const getLmnContraindications = ({
  context,
}: State<ILmnContext>): string[] => context.lmnContraindications
const getLmnNotQualified = ({ context }: State<ILmnContext>): boolean => context.lmnNotQualified
const getCustomerImage = ({
  context,
}: State<ILmnContext>): ICustomerImage | null => context.customerImage
const getLoading = ({ context }: State<ILmnContext>): boolean => context.loading
const getSmallLoading = ({ context }: State<ILmnContext>): boolean => context.smallLoading
const getCodeError = ({ context }: State<ILmnContext>): boolean => context.codeError

export {
  ILmnContext,
  ICustomerInfoProps,
  getCustomerInfo,
  getLmnStatus,
  getLmnState,
  getLmnStep,
  getLmnConditions,
  getLmnContraindications,
  getLmnNotQualified,
  getCustomerImage,
  getLoading,
  getSmallLoading,
  getCodeError,
  getLmnMerchantName,
  getLmnMerchantLogoUrl,
  getLmnMerchantWebsite,
  getLmnMerchantProcessor,
}
